export function reportSourceLabel(value) {
  const key = String(value || '').trim().toLowerCase()
  const labels = { bocha: '公开网站', bocha_web: '公开网站', '博查': '公开网站',
    xiaohongshu: '小红书', douyin: '抖音', tiktok: 'TikTok', tikhub: '公开社交平台' }
  if (key.startsWith('tikhub')) return labels[['xiaohongshu', 'douyin', 'tiktok'].find(name => key.includes(name)) || 'tikhub']
  if (key.startsWith('bocha')) return labels.bocha
  return labels[key] || value || '公开来源'
}
